import React from 'react';
export function ExperimentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2h8v2h-1v6l7 10v2H2v-2l7-10V4H8V2zm3 8.63L7.24 16h9.518l-3.76-5.37V4h-2v6.63z"
  }));
}